/* eslint-disable */
// @ts-nocheck

import styled from 'styled-components';
import { space, color, typography, layout, flexbox, grid, background, border, position, shadow } from 'styled-system';

import { FlexProps } from './types';

const Box = styled('div')<FlexProps>(
  {
    boxSizing: 'border-box',
    flexGrow: 1,
  },
  space,
  color,
  typography,
  layout,
  flexbox,
  grid,
  background,
  border,
  position,
  shadow
);

export default Box;
